// Zone maps
import pan from "assets/images/india-map/pan.png";
import north from "assets/images/india-map/north.png";
import east from "assets/images/india-map/east.png";
import west from "assets/images/india-map/west.png";
import south from "assets/images/india-map/south.png";

export default [
  {
    zone: [pan,"Pan-India"]
  },
  {
    zone: [north,"North"]
  },
  {
    zone: [east,"East"]
  },
  {
    zone: [west,"West"]
  },
  { zone: [south,"South"]
  },
];
